import api from '../api/client';

const catalogoPisteiroConfigService = {
  async getConfig(organizadorId) {
    const response = await api.get(`/configuracoes/catalogo-pisteiro/${organizadorId}`);
    return response.data;
  },

  async saveConfig(organizadorId, config) {
    const response = await api.post(`/configuracoes/catalogo-pisteiro/${organizadorId}`, config);
    return response.data;
  },

  async saveDataReferencia(organizadorId, dataReferencia) {
    const response = await api.patch(
      `/configuracoes/catalogo-pisteiro/${organizadorId}/data-referencia`,
      { data_referencia: dataReferencia }
    );
    return response.data;
  },
};

export default catalogoPisteiroConfigService;
